import { Directive, Inject, InjectionToken, Input, AfterViewInit, HostBinding, ElementRef, Renderer2, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ExternalValidationsService } from './ExternalValidationsService';
import { ICardComponent } from '../../workflows/ICardComponent';
import { ICardComponentInjectionToken } from './ExternalValidationDirective';


@Directive({
    selector: '[rowExternalValidation]',
    standalone: false
})
export class RowExternalValidationDirective  implements OnInit{
  
  @Input('rowExternalValidation') listName: string = null;
  @Input() tableIndex: number;
  @HostBinding('class.icon-error')
  @HostBinding('class.text-danger')
  @HostBinding('class.mr-2')
  private hasError = false;

  constructor(private externalValidationsService: ExternalValidationsService, @Inject(ICardComponentInjectionToken) private parentCard : ICardComponent) {
    externalValidationsService.errorsChangedSubject.subscribe(x => this.checkErrors());
    
  }
    ngOnInit(): void {
      this.checkErrors();
    }

  private checkErrors() {
    if (this.parentCard.cardExternalValidationErrors?.length > 0) {
      this.hasError = this.parentCard.cardExternalValidationErrors?.some(error => error.fieldName == this.listName && (error.tableLineNumber - 1) == this.tableIndex);
    }
    
  }
}
